import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const StakeSettingsModal = ({ show, values, onClose, onSave }) => {
  const [formValues, setFormValues] = useState(values || []);

  useEffect(() => {
    if (Array.isArray(values) && values.length) {
      setFormValues(values);
    }
  }, [values, show]);

  if (!show) return null;

  const handleChange = (index, newValue) => {
    setFormValues((prev) => {
      const next = [...(prev || [])];
      next[index] = newValue;
      return next;
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!onSave) return;

    const original = Array.isArray(values) ? values : [];
    const current = Array.isArray(formValues) ? formValues : [];
    const unchanged =
      original.length === current.length &&
      original.every(
        (val, idx) => Number(val) === Number(current[idx] ?? val),
      );

    if (unchanged) {
      toast.error("Update value to save.");
      return;
    }

    const normalized = (formValues || []).map((val, idx) => {
      const asNumber = Number(val);
      if (!Number.isFinite(asNumber) || asNumber <= 0) {
        const fallback =
          Array.isArray(values) && values[idx] != null ? values[idx] : 0;
        return Number(fallback) || 0;
      }
      return asNumber;
    });

    onSave(normalized);
  };

  const labels = formValues && formValues.length ? formValues : values || [];

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose} />
      <div
        className="modal stake-settings-modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="modal-content">
            <form onSubmit={handleSubmit} noValidate className="stack-setting">
              <h5 className="card-title">
                Stake{" "}
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                >
                  X
                </button>
              </h5>
              <div className="row my-2">
                {labels.map((label, index) => (
                  <div key={index} className="col-6">
                    <div className="input-group">
                      <span
                        id="basic-addon1"
                        className="input-group-text"
                      >
                        <b>
                          <small>{label}</small>
                        </b>
                      </span>
                      <input
                        type="number"
                        className="form-control"
                        id={`stackVal${index}`}
                        value={formValues[index]}
                        onChange={(e) =>
                          handleChange(index, e.target.value || "")
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
              <button type="submit" className="btn btn-thmemes mb-2">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default StakeSettingsModal;

